import { render, staticRenderFns } from "./SyncManagementModal.vue?vue&type=template&id=1b097370&"
import script from "./SyncManagementModal.vue?vue&type=script&lang=js&"
export * from "./SyncManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./SyncManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SyncManagementModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/SyncManagementModal.vue
// module id = 1673
// module chunks = 1